import { Action } from "@ptl/state";
import { ProducerUrlSessionObject } from "../interfaces/passive-referral-loader.interface";

const INITIAL_STATE: ProducerUrlSessionObject = {
    agentName: null,
    agentCode: null,
    agencyNumber: null,
    year: null,
    curBrandCode: null,
    userId: null,
    emailTypePreference: null,
    emailAddress: null,
    referralId: null
}

export class PassiveReferralsAction implements Action {
    type: string; 
    agentName?: string;
    agentCode?: string;
    agencyNumber?: string;
    year?: string
    curBrandCode?: string;
    userId?: string;
    emailTypePreference?: string;
    emailAddress?: string;
    referralId?: string;
}

const SAVE_PASSIVE_REFERRALS = 'SAVE_PASSIVE_REFERRALS';
const SET_PASSIVE_REFERRAL_EMAIL = 'SET_PASSIVE_REFERRAL_EMAIL';
const SET_PASSIVE_REFERRAL_ID = 'SET_PASSIVE_REFERRAL_ID';


export function savePassiveReferrals(agentName: string, agentCode: string, agencyNumber: string, year: string, curBrandCode: string, userId: string, emailTypePreference: string): PassiveReferralsAction {
    return {type: SAVE_PASSIVE_REFERRALS, agentName, agentCode, agencyNumber, year, curBrandCode, userId, emailTypePreference};
}

export function setPassiveReferralEmail(emailAddress: string): PassiveReferralsAction {
    return { type: SET_PASSIVE_REFERRAL_EMAIL, emailAddress };
}

export function setPassiveReferralId(referralId: string): PassiveReferralsAction {
    return { type: SET_PASSIVE_REFERRAL_ID, referralId };
}

export const PASSIVE_REFERRALS_REDUCER_NAME = 'PassiveReferrals';

export function PassiveReferrals(
    state: ProducerUrlSessionObject = INITIAL_STATE, action: PassiveReferralsAction) {
    const copiedState: ProducerUrlSessionObject = JSON.parse(JSON.stringify(Object.assign({}, state)));

    switch (action.type) {
        case SAVE_PASSIVE_REFERRALS: 
            copiedState.agentName = action.agentName;
            copiedState.agentCode = action.agentCode;
            copiedState.agencyNumber = action.agencyNumber;
            copiedState.year = action.year;
            copiedState.curBrandCode = action.curBrandCode;
            copiedState.userId = action.userId; 
            copiedState.emailTypePreference = action.emailTypePreference;
            return Object.assign({}, state, copiedState);
        case SET_PASSIVE_REFERRAL_EMAIL:
            copiedState.emailAddress = action.emailAddress;
            return Object.assign({}, state, copiedState);
        case SET_PASSIVE_REFERRAL_ID:
            copiedState.referralId = action.referralId;
            return Object.assign({}, state, copiedState);
        default:
            return state;
    }
}
